import { FV_LOOPS_ENDPOINT } from "../../endpoints";
import { fetcher } from "../../utils";
import {
    convertDynamicLoopsFromAPI,
    invertDynamicLoopsData,
} from "./converters";
import { DynamicLoops } from "./types";

export const getDynamicLoops = async ({ testId }: { testId: string }) => {
    const response = await fetcher(FV_LOOPS_ENDPOINT, {
        params: { test_id: testId },
    });

    return convertDynamicLoopsFromAPI(response);
};

export const submitDynamicLoops = async ({
    testId,
    values,
}: {
    testId: string;
    values: DynamicLoops;
}) => {
    const response = await fetcher(
        FV_LOOPS_ENDPOINT,
        {
            method: "PUT",
            params: { test_id: testId },
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(invertDynamicLoopsData(values)),
        },
        true
    );

    return convertDynamicLoopsFromAPI(response);
};
